export default __webpack_public_path__ + "static/media/contra_cleared.cbb2424e.svg";